export default __webpack_public_path__ + "static/media/notiication-icon.970205e0.svg";